import { render, staticRenderFns } from "./FormUser.vue?vue&type=template&id=60e0d024&scoped=true&"
import script from "./FormUser.vue?vue&type=script&lang=js&"
export * from "./FormUser.vue?vue&type=script&lang=js&"
import style0 from "./FormUser.vue?vue&type=style&index=0&id=60e0d024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0d024",
  null
  
)

export default component.exports